var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.infoData.length === 0)?_c('image-empty-link',{attrs:{"emptyLayout":_vm.emptyLayout}}):_c('image-link',{attrs:{"listLayout":_vm.listLayout,"infoData":_vm.infoData}})
}
var staticRenderFns = []

export { render, staticRenderFns }